"use client";

import { CtaSection } from "@/components/sections/cta";
import { cta } from "@/lib/data/services-search-dominance-seo";

export function CTA() {
  return (
    <CtaSection
      eyebrow={cta.eyebrow}
      title={cta.title}
      intro={cta.intro}
      promises={cta.promises}
      ctaPrimary={cta.ctaPrimary}
      ctaSecondary={cta.ctaSecondary}
      trustBar={cta.trustBar}
      accent={cta.accent}
      secondaryAccent={cta.secondaryAccent}
    />
  );
}
